export default {
  playAriaLabel: {
    id: 'product_page_carousel_video_button_aria_label',
    defaultMessage: 'Play video for {productName}',
  },
  pauseAriaLabel: {
    id: 'product_page_carousel_video_pause_aria_label',
    defaultMessage: 'Pause video for {productName}',
  },
  marketingVideoGenericTitle: {
    id: 'product_page_carousel_video_marketing_generic_title',
    defaultMessage: 'Used vs Verified',
  },
  marketingVideoIphoneTitle: {
    id: 'product_page_carousel_video_marketing_iphone_title',
    defaultMessage: 'iPhone',
  },
  marketingVideoAndroidTitle: {
    id: 'product_page_carousel_video_marketing_android_title',
    defaultMessage: 'Android',
  },
  marketingVideoLaptopTitle: {
    id: 'product_page_carousel_video_marketing_laptop_title',
    defaultMessage: 'Laptop',
  },
  marketingVideoMacbookTitle: {
    id: 'product_page_carousel_video_marketing_macbook_title',
    defaultMessage: 'Macbook',
  },
  marketingVideoAirpodsTitle: {
    id: 'product_page_carousel_video_marketing_airpods_title',
    defaultMessage: 'Airpods',
  },
} as const
